import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../../components/Preloader/Preloader';
import PracticeCard from '../Contest/PracticeCard';
import paths from '../../paths';
import { getPracticeCasesByFilter } from '../../utils/api/services/contest';

export default class PracticeNews extends Component {
  constructor(props) {
    super(props);

    this.practiceCount = 2;

    this.state = {
      isLoading: false,
      practice: [],
    };
  }

  static propTypes = {
  };

  componentWillMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ isLoading: true });
    getPracticeCasesByFilter(null, null, 'date', this.practiceCount, 0)
      .then((result) => {
        this.setState({
          practice: result.data,
        });
      })
      .catch ((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    const { practice, isLoading } = this.state; 

    if (!practice.length) {
      return (<React.Fragment />);
    }

    return (
      <React.Fragment>
        {isLoading ? (<Preloader />) :
          (
            <React.Fragment>
            <h1 className="title -primary">Новое в разделе Практика</h1>
            <div className="section">
              <div className="card">
                {practice.map(item => (
                  <PracticeCard key={item.id} practice={item} />
                ))}
              </div>

              <div className="section-more">
                <Link to={paths.advocates.practice} className="btn -more">
                  Все материалы раздела Практика
              </Link>
              </div>
            </div>
            </React.Fragment>
          )}
      </React.Fragment>
      );
  }
}


  